export const NOT_FOUND_TITLE_TEXT = 'Page Not Found';
